import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Logo from '../../Atoms/Logo/Logo';
import MainNav from './Nav/Nav';
import { Brand, HeaderWrapper, InnerWrapper, MetaIcons } from './Header.style';

var Header = function Header(_ref) {
  var navItems = _ref.navItems,
      metaIcons = _ref.metaIcons,
      campaign = _ref.campaign,
      rotate = _ref.rotate,
      rest = _objectWithoutProperties(_ref, ["navItems", "metaIcons", "campaign", "rotate"]);

  return React.createElement(HeaderWrapper, Object.assign({
    navItems: true
  }, rest), React.createElement(InnerWrapper, null, React.createElement(Brand, {
    href: "/",
    title: "Go to ".concat(campaign, " homepage")
  }, React.createElement(Logo, {
    rotate: rotate,
    campaign: campaign
  })), React.createElement(MainNav, {
    navItems: navItems
  }), React.createElement(MetaIcons, null, metaIcons)));
};

Header.defaultProps = {
  navItems: {},
  campaign: 'Comic Relief',
  rotate: false
};
export default Header;